"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v4 = void 0;
/**
 * Provides a poly-filled UUID v4 function. Environments that have access to the global crypto API
 * should use the randomUUID function. Others can fall back to the uuid library
 */
function v4() {
    if (typeof crypto === 'object' &&
        typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    else {
        /* eslint-disable @typescript-eslint/no-var-requires */
        return require('uuid').v4();
        /* eslint-enable @typescript-eslint/no-var-requires */
    }
}
exports.v4 = v4;
